import { Button, Typography } from '@mui/material';
import { useMutation, useQueryClient } from 'react-query';
import { PayLoanPrepayment } from '../../../../services/payment.service';
import { IContainerApp } from '../containerApp/IContainerApp';
import { LOAN_CARD_INFO } from '../../../../config/cacheKey';
import { IGetLoansInfoResponse } from '../../../../models/registration.model';
import SimpleCard from '../../../../components/card/simpleCard/simpleCard';
import CheckDocumentIcon from '../../../../components/icons/CheckDocumentIcon';

const PrePayment = ({ referenceKey, setStep }: IContainerApp) => {
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData<IGetLoansInfoResponse>(LOAN_CARD_INFO)
    const { mutateAsync: PayLoanPrepaymentMutate } = useMutation(
        PayLoanPrepayment,
        {
            onSuccess: (data) => {
                if (data?.redirectionToBankUrl) {

                    window.location.href = data.redirectionToBankUrl;

                    // window.open(data.redirectionToBankUrl, '_blank');
                } else {
                    console.error("Bank URL not found in response");
                }
            },
            onError: (error) => {
                console.error("Payment failed", error);
            }

        });

    const handlePryPayment = () => {

        const callbackUrl = window.location.origin;
        PayLoanPrepaymentMutate({ referenceKey: referenceKey!, callbackUrl });
    }
    return (
        <div className=' mx-4 mt-5 text-white'>
            <div className='flex flex-col justify-center items-center text-justify gap-2 mb-12'>
                <div className="flex flex-col items-center justify-center gap-3">
                    <CheckDocumentIcon className='text-[var(--primary-text-color)]' />
                    <Typography
                        sx={{ fontSize: '.9em' }}
                        className="primaryColorLight-900 !mt-10 text-center"
                    >
                        درخواست شما مورد تایید قرار گرفت.
                        لطفا نسبت به پرداخت هزینه خدمات اقدام فرمایید.
                    </Typography>
                    <Typography
                        sx={{ fontSize: '.9em' }}
                        className="text-[#A8946E] !mt-2 text-center "
                    >
                        پرداخت هزینه خـدمات جهت استفاده از سـرویس خرید قسطی کمان ضروری است. این هزینه جدا از مبلغ اقساط است و قابل استرداد نمیباشد.
                    </Typography>

                </div>


                <SimpleCard>
                    <div className='w-full'>
                        <div className='w-full' style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>

                                <span style={{ fontSize: "0.9rem", }}> اعتبار خرید (ریال) </span>
                            </div>
                            <div style={{ alignContent: "flex-end" }}>
                                <span style={{ fontSize: "1rem", color: "text-[#212121]" }}> {data?.creditAmount.toLocaleString('fa')} </span>
                            </div>
                        </div>
                        <hr style={{ color: '#D7DBEC', paddingBottom: "10px", borderTop: "2px solid" }} />
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>

                                <span style={{ fontSize: "0.9rem", }}> هزینه خدمات(ريال)</span>
                            </div>
                            <div style={{ alignContent: "flex-end" }}>
                                <span style={{ fontSize: "1rem", color: "text-[#212121]" }} > &nbsp;  {data?.prepaymentAmount.toLocaleString('fa')} </span>
                            </div>
                        </div>
                    </div>
                </SimpleCard>
            </div>

            <Button
                fullWidth
                onClick={() => handlePryPayment()}
                // disabled={itemAmounts.every(x => !x.isChecked)}
                sx={{
                    marginBottom: "8px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center", height: "42px",
                    paddingInline: "1rem",
                    backgroundColor: 'var(--button-color) !important',
                    color: 'var(--bg-color) !important',
                    // opacity: itemAmounts.every(x => !x.isChecked) ? 0 : 1
                }}>
                <Typography marginX={"8px"} >
                    پرداخت هزینه خدمات
                </Typography>

            </Button>
        </div>
    )
}

export default PrePayment